import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { getSampleByQreIdMaxIpsosIdOptions } from '../api/generated-evs/@tanstack/react-query.gen';

export const useMaxIpsosId = (qreId: string, enabled = true): UseQueryResult<number | null> => {
  return useQuery({
    ...getSampleByQreIdMaxIpsosIdOptions({ path: { qreId } }),
    enabled: enabled && !!qreId,
    select: (data) => data.maxId,
  });
};
